import { ref, reactive } from 'vue';
import type { CustomerAddress } from '@/types/customer';

interface AddressFormData {
  address: string;
  apartment: string;
  neighborhood: string;
  city: string;
  postal_code: string;
  reference_point: string;
  is_default: boolean;
}

export const useAddressForm = () => {
  const showAddForm = ref(false);
  const editingAddress = ref<CustomerAddress | null>(null);
  const isSubmitting = ref(false);

  const addressForm = reactive<AddressFormData>({
    address: '',
    apartment: '',
    neighborhood: '',
    city: '',
    postal_code: '',
    reference_point: '',
    is_default: false
  });

  const resetForm = () => {
    Object.assign(addressForm, {
      address: '',
      apartment: '',
      neighborhood: '',
      city: '',
      postal_code: '',
      reference_point: '',
      is_default: false
    });
  };

  const startEditing = (address: CustomerAddress) => {
    editingAddress.value = address;
    Object.assign(addressForm, {
      address: address.address,
      apartment: address.apartment,
      neighborhood: address.neighborhood,
      city: address.city,
      postal_code: address.postal_code,
      reference_point: address.reference_point,
      is_default: address.is_default
    });
    showAddForm.value = true;
  };

  const cancelForm = () => {
    showAddForm.value = false;
    editingAddress.value = null;
    resetForm();
  };

  const startAdding = () => {
    editingAddress.value = null;
    resetForm();
    showAddForm.value = true;
  };

  const getFormData = () => ({ ...addressForm });

  const validateForm = (): boolean => {
    return addressForm.address.trim().length > 0;
  };

  return {
    showAddForm,
    editingAddress,
    isSubmitting,
    addressForm,
    resetForm,
    startEditing,
    cancelForm,
    startAdding,
    getFormData,
    validateForm,
  };
};
